enum PoolType {
	Avg = "AVG",
	Max = "MAX"
}

export default PoolType;